import CreateAppSystemRequestModelBase from '../_generated/modelBases/create-app-system-request-model-base';

export default class CreateAppSystemRequestModel extends CreateAppSystemRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
